import React, { useState } from "react";
import { Input } from "antd";
import AddressSelection from "../../components/addressSelection/addressSelection";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Address } from "../../types/types";
import { getLatLongForGivenAddress } from "../../utils/utils";
import CustomIcon from "../../components/icons/CustomIcon";

interface Props {
    title: string;
    placeholder: string;
    onChange?: any;
    disabled?: boolean;
    data?: any;
    className?: string;
    rules?: any;
    setValue?: any;
    setError?: any;
    control?: any;
    name: string;
    pattern?: any;
    onBlur?: any;
    recordId: string;
}
const AdressInputComponent: React.FC<Props> = ({
    title,
    placeholder,
    onChange,
    disabled,
    data,
    className,
    setValue,
    setError,
    rules,
    control,
    name,
    pattern,
    onBlur,
    recordId
}) => {

    const [openAddressSelection, setOpenAddressSelection] = useState(false);
    const [choosenAddress, setChoosenAddress] = useState<Address | undefined>();
    const [warning, setWarning] = useState<string>();

    const onAddressSelection = async (val: Address) => {

        setValue(name, val.addressFrom);
        setChoosenAddress(val);
        onChange(val.addressFrom);

        if (val.latitude === null || val.latitude === undefined || val.latitude === 0) {
            const response = await getLatLongForGivenAddress(val);
            if (response?.error?.response?.data?.error) {
                setWarning(response?.error?.response?.data?.error);
                return;
            }
        }

        setWarning("");
    }

    // useEffect(() => {
    //     if (data !== undefined && data !== null) {
    //         setValue(name, data);
    //         if (onChange) {
    //             onChange(data);
    //         }
    //     }
    // }, [data]);

    const handleClearButtonClick = (e: any) => {
        e.stopPropagation(); // Prevent click event from reaching the input field
        setValue(name, "");
        onChange("");
    };

    return (

        <>
            <Input
                title={title}
                placeholder={placeholder}
                disabled={disabled}
                className={className}
                value={choosenAddress?.addressFrom || data}
                name={name}

                suffix={
                    choosenAddress ?(
                            <span
                                style={{ cursor: "pointer" }}
                                onClick={handleClearButtonClick}
                            >
                                <CloseCircleOutlined rev={undefined} />
                            </span>
                        ) : (<CustomIcon className="mx-1 site-form-item-icon text-primary opacity-5" name="searchLens"></CustomIcon>)
                }
                onMouseDown={() => { setOpenAddressSelection(true) }}
                onClick={() => { setOpenAddressSelection(true) }}
                onFocus={() => { setOpenAddressSelection(true) }}
                
                maxLength={title === "email" ? 50 : (Number(rules?.maxSize) ?? 1000)}

            />
            {openAddressSelection ? (<AddressSelection choosenAddress={choosenAddress} loanNo={recordId ?? ""} onSelection={(val: any) => onAddressSelection(val)} onClose={() => { setOpenAddressSelection(false); }}></AddressSelection>
            ) : (<></>)}
            {warning && (
                <div className="ant-form-item-explain-warning">
                    {warning}
                </div>
            )}

        </>

    );
};

export { AdressInputComponent };
